<template>
    <div>
        <template v-if="!finished">
            <b-row>
                <b-col>
                    <h3>
                        Bezig met laden...
                    </h3>
                </b-col>
            </b-row>
        </template>
        <template v-else>
            <b-row>
                <b-col>
                    Op deze pagina kunt u zich uitschrijven uit {{skin.region}}. Weet u dit zeker?
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <h3>
                        Wilt u zich uitschrijven?
                    </h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-radio-group id="wantsToUnregister" v-model="form.wantsToUnregister">
                        <b-form-radio :value="true">Ja</b-form-radio>
                        <b-form-radio :value="false">Nee</b-form-radio>
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <template v-if="form.wantsToUnregister">
                <b-row>
                    <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <h3>
                            Waarom wilt u zich uitschrijven?
                        </h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-select
                            :options="formData.reasons"
                            v-model="$v.form.unregisterReason.$model"
                            required
                            :state="$v.form.unregisterReason.$dirty ? !$v.form.unregisterReason.$invalid : undefined"
                        />
                    </b-col>
                </b-row>
            </template>
            <FormButtons @next="next" @previous="$emit('previous')"/>
            <vuelidateErrorDialog :validator="$v.form" :state="errDialogVisible" parent="Unregister" @onClose="errDialogVisible = false"/>
            <b-modal
                    title-html="<i class='fal fa-exclamation-circle'></i>&nbsp;&nbsp;Weet u het zeker?"
                    id="unregisterConfirm"
                    size="lg"
                    ok-title="Uitschrijving bevestigen"
                    ok-variant="danger"
                    @ok="submit"
                    cancel-title="Nee, ga terug"
                    cancel-variant="success">
                <b-row>
                    <b-col>
                        <p>
                            Weet u zeker dat u zich uit wil schrijven?
                        </p>
                    </b-col>
                </b-row>
            </b-modal>
        </template>
    </div>
</template>

<script>
    import FormButtons from '@/components/_registration/FormButtons'
    import {accountService} from "../../_services";
    import { required } from 'vuelidate/lib/validators'
    import vuelidateErrorDialog from "@/components/VuelidateErrorDialog";

    export default {
        components: { FormButtons, vuelidateErrorDialog },
        data: () => {
            return {
                highlightInvalid: false,
                errDialogVisible: false,
                skin: {
                    region: process.env.VUE_APP_REGION,
                },
                finished: false,
                form: {
                    wantsToUnregister: false,
                    unregisterReason: null,
                },
                formData: {
                    reasons: []
                }
            }
        },
        validations: {
            form: {
                unregisterReason: { required }
            }
        },
        computed: {
            validated () {
                return !this.$v.$invalid
            }
        },
        name: 'Privacy',
        mounted() {
            accountService.getUnregisterReasons().then((data) => {
                this.formData.reasons = data
                this.finished = true
            })
        },
        methods: {
            next () {
                if(this.form.wantsToUnregister) {
                    this.$v.$touch()
                    if (this.validated) {
                        this.$bvModal.show('unregisterConfirm')
                    } else {
                        this.highlightInvalid = true
                        this.errDialogVisible = true
                    }
                } else {
                    this.$emit('previous')
                }
            },
            submit () {
                if(this.form.unregisterReason !== null) {
                    accountService.remove(this.form.unregisterReason).then(() => {
                        window.location.href = '../logout'
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>